<template>
    <router-view id="page-content-wrapper"></router-view>
</template>

<script>
export default {
    name: "Hospital"
}
</script>

<style scoped>

</style>